<template>
  <div class="row">
    <div class="col-4 border-bottom border-left py-2">
      <span
        :title="field.level"
        :class="`mr-2 rounded-circle align-middle questionnaire-dot questionnaire-dot-${strength}`">
      </span>

      {{field.label}}
    </div>

    <div class="col-4 border-bottom border-left py-2">
      <div v-if="field.type !== 'checkbox'">
        {{field.answer.value}}
      </div>
    </div>
    <div
        class="col-4 border-bottom border-left py-2"
        @click="addComment">
      <div
          v-if="sending"
          class="text-primary">
        Loading...
      </div>
      <div v-else-if="commenting">
        <textarea
            v-model="comment"
            rows="1"
            type="text"
            class="form-control"
            @blur="sendComment">
        </textarea>
      </div>
      <div v-else>
        {{field.answer.comment}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QuestionnaireField',

    props: ['field', 'commentAnswer'],

    data() {
      return {
        strength: 0,
        sending: false,
        commenting: false,
        comment: '',
      };
    },

    created() {
      this.strength = [80, 60, 40, 20, 1, 0].find(l => l <= this.field.level) || 0;
      this.comment = this.field.answer.comment;
    },

    methods: {
      addComment () {
        if (this.sending || this.commenting) {
          return;
        }

        this.commenting = true;
      },

      async sendComment() {
        this.sending = true;

        try {
          await this.commentAnswer(this.field.answer.id, this.comment);

          this.commenting = false;
        } catch (e) {
          //do nothing
        }

        this.sending = false;
      },
    },
  };
</script>

<style lang="scss">
.questionnaire-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
}

.questionnaire-dot-0 {
  color: #333;
  background-color: #ccc;
  border: 1px solid #ccc;
}

.questionnaire-dot-1 {
  background-color: darkred;
  border: 1px solid darkred;
}

.questionnaire-dot-20 {
  background-color: #dc3545;
  border: 1px solid #dc3545;
}

.questionnaire-dot-40 {
  background-color: #ffc107;
  border: 1px solid #ffc107;
}

.questionnaire-dot-60 {
  background-color: #91C139;
  border: 1px solid #91C139;
}

.questionnaire-dot-80 {
  background-color: #059526;
  border: 1px solid #059526;
}
</style>
